import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import css from "./MobileHeader.module.css";
import { languages } from "../../constants";
import { getConfig } from "../../config";

const MobileHeader = ({ onMenuToggle, isMenuOpen }) => {
  const { t, i18n } = useTranslation();
  const customLogo = useSelector((state) => state.builder.adminConfig?.logo);
  const logo = customLogo || getConfig().logo;

  const handleLanguageChange = (event) => {
    const selectedLanguage = event.target.value;
    i18n.changeLanguage(selectedLanguage);
    localStorage.setItem("i18nextLng", selectedLanguage);
  };

  const currentLanguage = localStorage.getItem("i18nextLng") || "en";

  return (
    <header className={css.header}>
      <button
        className={css.menuButton}
        onClick={onMenuToggle}
        aria-label={isMenuOpen ? t("close-menu") : t("open-menu")}
      >
        <div className={`${css.hamburger} ${isMenuOpen ? css.open : ""}`}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>

      <div className={css.logo}>
        <img src={logo} alt="GWT Logo" className={css.logoImage} />
      </div>

      <div className={css.languageSelector}>
        <select
          onChange={handleLanguageChange}
          className={css.selectLanguage}
          value={currentLanguage}
          aria-label={t("select-language")}
        >
          {languages.map((language) => (
            <option key={language.code} value={language.code}>
              {language.flag} {language.code.toUpperCase()}
            </option>
          ))}
        </select>
      </div>
    </header>
  );
};

export default MobileHeader;
